<template>
        <div>
                <el-dialog
                        :title="title"
                        width="65%"
                        :bottom="0"
                        top="60px"
                        append-to-body
                        :fullscreen="dialogFull"
                        :close-on-click-modal="false"
                        :visible.sync="dialogVisible"
                        :destroy-on-close="true"
                        :before-close="handleClose"
                        v-loading="loading"
                        id="choiceDeviceContractv2"

                >
                <template slot="title">
                        <div class="avue-crud__dialog__header">
                                <span class="el-dialog__title">
                                        {{title}}
                                </span>
                                <i class="el-icon-full-screen" style="margin-right:20px;position:relative;top:-1px"  @click="dialogFullChange"></i>
                                
                        </div>
                        <el-divider></el-divider>
                </template>
                <div :style="'height:'+ dialogBodyHight + 'px;overflow:hidden;'">
                        <choiceContract v-if="dialogVisible" style="margin:0 10px" :showButton="true"  ref="choiceContract" :projectId='projectId'   @getConstract="getContract"></choiceContract>
                </div>
                <template slot="footer">
                        <el-divider></el-divider>
                        <div>
                              <el-button icon="el-icon-circle-plus-outline" size="small" @click="getContract" type="primary">提 交</el-button>  
                              <el-button icon="el-icon-circle-close" style="margin-right:10px" size="small" @click="handleClose(false)">取 消</el-button>
                        </div>
                </template>
                </el-dialog>
        </div>
</template>
<script>
import choiceContract from '@/components/choiceContract/choiceContract-v2';
export default {
        props:{
               projectId :{
                       type:String,
                       default:'',
               },
               title:{
                       type:String,
                       default:'关联合同',
               }
        },
        components:{
                choiceContract
        },
        data(){
                return{
                        dialogVisible:false,
                        dialogFull:false,
                        loading:false,
                        dialogBodyHight:0,


                }
        },
        mounted(){
                 this.dialogFull = false;
                let bodyHight = document.body.clientHeight;

                this.dialogBodyHight = bodyHight - 320;

        },
        methods:{
                openDialog(){
                        this.dialogVisible = true;
                },
                // 选择合同提交方法
                getContract(){
                        let contract =  this.$refs.choiceContract.submitContractV2();
                        this.dialogVisible = false;
                        this.$emit('getConstract', contract);
                },
                // 取消选择合同
                contractCancleOperate(){
                        
                },
                // 弹窗关闭前
                handleClose(done){
                        let self = this;
                        this.$confirm('确认关闭?', '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning',
                        })
                        .then(()=> {
                                if(done){
                                        done();
                                        this.selectTimeFlag = false;

                                }else{
                                        this.selectTimeFlag = false;
                                        self.dialogVisible = false;
                                }
                        })
                        .catch(()=> {
                                
                        });
                },
                dialogFullChange(){
                        let bodyHight = document.body.clientHeight;
                        this.dialogFull = !this.dialogFull;
                        if(this.dialogFull){
                                this.dialogBodyHight = bodyHight - 180;
                                this.$refs.choiceContract.dialogFullChange(true);
                        }else{
                                this.dialogBodyHight = bodyHight - 320;
                                this.$refs.choiceContract.dialogFullChange(false);
                        }
                },
        }
}
</script>
<style lang="scss">
#choiceDeviceContractv2{
        .el-dialog__body{
                // padding: 0 20px;
                padding-top: 0 !important;
                padding-bottom: 0 !important;
        }
        .el-dialog__header{
                // padding: 20px 20px 0 20px;
                 padding-bottom: 0 !important;
        }
        .el-dialog__footer{
                padding-top: 0 !important;
        }
}
</style>>